<app-menu-template3>
  <main>
    <section class="row ml-5 mr-5 mt-4 mb-3 rounded shadow-sm bg-white">
      <header class="row d-flex align-items-center w-100 p-4">
        <div class="col-sm-12 col-md-4 d-flex flex-row">
          <img src="/assets/icons/info-establecimiento.png" class="ml-5 d-inline-block rounded-circle" alt="" height="38">
          <label class="ml-3 small text-muted mb-0">Nombre del establecimiento<br><strong class="h6 text-dark font-weight-bold">{{informacionEstablecimiento.razon_social}}</strong></label>
        </div>
        <div class="col-sm-12 col-md-2">
          <label class="small text-muted mb-0">Número RNT<br><strong class="h6 text-dark font-weight-bold">{{informacionEstablecimiento.codigo_rnt}}</strong></label>
        </div>
        <div class="col-sm-12 col-md-2">
          <label class="small text-muted mb-0">Radicado inscrito<br><strong class="h6 text-dark font-weight-bold">{{informacionEstablecimiento.numero_radicacion}}</strong></label>
        </div>
        <div class="col-sm-12 col-md-2">
          <label class="small text-muted mb-0">Estado<br><strong class="h6 text-dark font-weight-bold">{{informacionEstablecimiento.desc_estado_rnt}}</strong></label>
        </div>
      </header>
    </section>
    <article class="row ml-5 mr-5 mt-3 mb-3 rounded shadow-sm bg-white">
      <header class="col-1 d-flex flex-column">
        <section class="row d-flex justify-content-center">
          <div class="col-12 text-center pt-3" routerLinkActive="active">
            <a class="nav-item nav-link p-0 " [routerLink]="['/ver-detalle/' + codigo_camara + '/'+solicitud_id + '/establecimientos']">
              <img src="../../../../../../../assets/icons/rnt.png" class="" alt="">
              <p class="small font-weight-bold text-opt mt-1">RNT</p>
            </a>
          </div>
        </section>
      </header>
      <section class="col-11">
        <router-outlet></router-outlet>
      </section>
    </article>

  </main>
</app-menu-template3>